export const SLICE_NAME = "recommendations";